export class SortDto {
  sorted: boolean;
  unsorted: boolean;

  constructor(sortData?: SortDto) {
    Object.assign(this, sortData || {});
  }
}
